import "core-js/modules/es.string.link.js";
import { SIcon } from '@strana-artw/ui-kit';
import { YM_HIDE_CONTENT } from '@/shared/constants';
import { NameOutput } from '@/shared/ui/outputs';
export default {
  name: 'PagePersonInfo',
  components: {
    NameOutput: NameOutput,
    SIcon: SIcon
  },
  props: {
    link: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    role: {
      type: String,
      default: ''
    },
    fullName: {
      type: [Object, String],
      default: ''
    },
    agencyName: {
      type: String,
      default: ''
    },
    isRepres: {
      type: Boolean,
      default: false
    },
    nameHiddenOnSm: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup() {
    return {
      YM_HIDE_CONTENT: YM_HIDE_CONTENT
    };
  },
  computed: {
    showAgent: function showAgent() {
      var _this$link;
      return ((_this$link = this.link) === null || _this$link === void 0 ? void 0 : _this$link.title) && this.isRepres;
    },
    isFullNameString: function isFullNameString() {
      return typeof this.fullName === 'string';
    }
  }
};